import { Icon, type IconProps } from "@chakra-ui/react";
import React from "react";

export function MailIcon(props: IconProps) {
  return (
    <Icon width="20px" height="20px" viewBox="0 0 20 20" fill="none" {...props}>
      <g stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3.333 3.333h13.334c.916 0 1.666.75 1.666 1.667v10c0 .916-.75 1.666-1.666 1.666H3.333c-.916 0-1.666-.75-1.666-1.666V5c0-.917.75-1.667 1.666-1.667Z" />
        <path d="M18.333 5 10 10.833 1.667 5" />
      </g>
    </Icon>
  );
}
